export * from "-!../../../../node_modules/vue-loader/lib/loaders/templateLoader.js??vue-loader-options!../../../../node_modules/vue-loader/lib/index.js??vue-loader-options!./PostShare.vue?vue&type=template&id=2718a0af&scoped=true&"


//////////////////
// WEBPACK FOOTER
// ./scripts/vue/PostShare.vue?vue&type=template&id=2718a0af&scoped=true&
// module id = 117
// module chunks = 0